import React, { useState } from "react";
import Joppe from "../afbeeldingen/Joppe.jpg";

const About = ({ darkMode }) => {
  const [showMore, setShowMore] = useState([false, false, false, false]);

  const toggleShowMore = (index) => {
    const updatedStates = [...showMore];
    updatedStates[index] = !updatedStates[index];
    setShowMore(updatedStates);
  };

  const cardData = [
    {
      title: "Waarom IT?",
      text: `Ik heb gekozen voor IT omdat ik van jongs af aan zeer geïnteresseerd was in wat er allemaal mogelijk is met IT en hoe het werkt. Ik heb gekozen voor de richting application development, omdat ik in het middelbaar onderwijs al veel heb geprogrammeerd en dit zo leuk vond dat ik besloot deze richting te volgen.`,
    },
    {
      title: "Toekomstige dromen",
      text: `Mijn droom is om later een belangrijke rol te vervullen binnen een groot en invloedrijk bedrijf, zoals bijvoorbeeld Google. Welk bedrijf dat precies zal zijn, weet ik nog niet, maar ik zie mezelf werken bij een internationaal bedrijf met veel mogelijkheden. Met mijn ambities en motivatie denk ik dat ik na een paar jaar werkervaring een mooie functie binnen zo’n bedrijf kan bereiken.`,
    },
    {
      title: "Hobby's",
      text: `Mijn hobby's zijn voetbal en darten. Voetballen doe ik bij de voetbalclub Sint-Jozef Rijkevorsel. Ik ben begonnen met voetballen vanaf mijn vijf à zes jaar. Toen ben ik begonnen bij de voetbalclub KVV Vosselaar. Daar ben ik blijven voetballen tot mijn 17 jaar. Daarna ben ik naar Sint-Jozef Rijkevorsel gegaan en daar voetbal ik nog altijd. Darten doe ik niet bij een club, maar dat doe ik gewoon met een paar vrienden in de achtertuin.`,
    },
    {
      title: "Soft skills",
      text: (
        <>
          <p>
            Ik heb heel wat verschillende soft skills. Maar de voornaamste soft
            skills zijn:
          </p>
          <ul>
            <li>Communicatieve vaardigheden</li>
            <li>Probleemoplossend denken</li>
            <li>Teamwork</li>
            <li>Zelfstandig werken</li>
            <li>Leergierigheid</li>
            <li>Flexibiliteit</li>
            <li>Behulpzaam</li>
            <li>Empathie</li>
          </ul>
        </>
      ),
      summary:
        "Ik heb verschillende soft skills, waaronder communicatie, teamwork en probleemoplossend denken.",
    },
  ];

  return (
    <section
      id="about"
      className="my-5"
      style={{
        backgroundColor: darkMode ? "#333333" : "#F8F9FA", // Dark and light mode backgrounds
        color: darkMode ? "#FFFFFF" : "#4D4D4D", // Text color
        padding: "60px",
      }}
    >
      {/* Section with Image and Contact Details */}
      <div className="text-center mb-5">
        <h2>Over mij</h2>
      </div>
      <div className="container mb-5">
        <div className="row align-items-center">
          {/* Profile Image */}
          <div className="col-md-6 text-center">
            <img
              src={Joppe}
              alt="Joppe Dierckx"
              className="img-fluid rounded-circle"
              style={{
                width: "250px",
                height: "250px",
                objectFit: "cover",
                objectPosition: "center 20%",
                border: darkMode ? "5px solid #555" : "5px solid #ddd",
                borderRadius: "50%",
              }}
            />
          </div>
          {/* Contact Details */}
          <div className="col-md-6">
            <h2>Contactgegevens</h2>
            <ul className="list-unstyled">
              <li>
                <strong>Naam:</strong> Joppe Dierckx
              </li>
              <li>
                <strong>Email:</strong>{" "}
                <a href="mailto:joppe.dierckx@hotmail.be">joppe.dierckx@hotmail.be</a>
              </li>
              <li>
                <strong>Telefoon:</strong> +32 492 83 65 87
              </li>
              <li>
                <strong>LinkedIn:</strong>{" "}
                <a
                  href="https://www.linkedin.com/in/joppe-dierckx-aa8776251/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </li>
              <li>
                <strong>Github:</strong>{" "}
                <a
                  href="https://github.com/JoppeDierckx"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Github
                </a>
              </li>
              <li>
                <strong>Locatie:</strong> Vosselaar, België
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Cards Section */}
      <div className="row justify-content-center">
        {cardData.map((card, index) => (
          <div key={index} className="col-md-3 col-sm-6 mb-4">
            <div
              className="card p-3 shadow-sm d-flex flex-column h-100"
              style={{
                backgroundColor: darkMode ? "#444444" : "#FFFFFF", // Card background
                color: darkMode ? "#FFFFFF" : "#4D4D4D", // Card text color
              }}
            >
              <h4>{card.title}</h4>
              <div>
                {showMore[index] ? (
                  card.text
                ) : card.summary ? (
                  <p>{card.summary}</p>
                ) : (
                  <p>{card.text.slice(0, 150)}...</p>
                )}
              </div>
              <button
                className="btn btn-link p-0 mt-auto"
                onClick={() => toggleShowMore(index)}
              >
                {showMore[index] ? "Sluiten" : "Lees meer"}
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* CV Section */}
      <div className="text-center mt-4">
        <h2>Mijn CV</h2>
        <div className="mt-3">
          <a
            href="/CV_Joppe_Dierckx.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary me-2"
          >
            Open Mijn CV
          </a>
          <a
            href="/CV_Joppe_Dierckx.pdf"
            download
            className="btn btn-secondary"
          >
            Download Mijn CV
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
